<template>
  <div class="detail-content-box">
    <p class="detail-content-title"><span>成果简介</span></p>
    <div class="ql-container ql-snow">
      <div class="ql-editor" v-html="info.description"></div>
    </div>
    <p class="detail-content-title"><span>成果背景</span></p>
    <div class="ql-container ql-snow">
      <div class="ql-editor" v-html="info.background"></div>
    </div>
    <p class="detail-content-title"><span>成果建设内容</span></p>
    <div class="ql-container ql-snow">
      <div class="ql-editor" v-html="info.content"></div>
    </div>
    <p class="detail-content-title"><span>实施效果</span></p>
    <div class="ql-container ql-snow">
      <div class="ql-editor" v-html="info.effect"></div>
    </div>
  </div>
</template>

<script>
import { downloadFile } from "@/api/scene";
import { mapGetters } from "vuex";
export default {
  props: ["info"],
  computed: mapGetters(["userInfo"]),
  methods: {
    downloadAnnex(id, name) {
      if (!this.userInfo) {
        this.$message.warning("您还未登录！");
        return;
      }
      downloadFile(id).then((res) => {
        if (!res) {
          return;
        }
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.detail-content-box .ql-container.ql-snow {
  border: none;
}
.detail-content-title {
  font-size: 16px;
  line-height: 16px;
  position: relative;
  margin-bottom: 36px;
  > span {
    display: block;
    line-height: 16px;
    position: relative;
    z-index: 2;
  }
  &::after {
    content: "";
    position: absolute;
    width: 64px;
    height: 8px;
    background: #1abc9c;
    left: 0;
    bottom: -4px;
  }
}
.more-dynamic-detail-content-annex {
  margin-top: 24px;
  > div {
    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      padding: 0 16px;
      margin-bottom: 16px;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
      > div {
        display: flex;
        align-items: center;
        > img {
          margin-right: 8px;
        }
        > p {
          max-width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      > span {
        color: #1abc9c;
        cursor: pointer;
        display: none;
      }
      &:hover {
        background: #f5f5f5;
        > span {
          display: block;
        }
      }
    }
  }
}
</style>
